<template>
    <div class="mt-4">
        <v-row v-if="!dashBoards.length || projectStatus === 'beforeTrial'" justify="center">
            <div>
                Для отображения доступных виджетов
                <span v-if="projectStatus === 'beforeTrial'"
                    ><a @click="goToBotConnectorCreate">подключите бота</a> или</span
                >
                <a @click="goToBilling"> приобретите тариф</a>
            </div>
        </v-row>
        <template v-if="dashBoards.length && projectStatus !== 'beforeTrial'">
            <!-- Секция Коммуникации -->
            <div v-if="groupedDashboards.communications.length > 0" class="mb-8">
                <h3 class="dashboard-group-title">Коммуникации</h3>
                <div class="dashboard-cards-grid">
                    <DashboardCard
                        v-for="(item, i) in groupedDashboards.communications"
                        :key="`communications-${i}`"
                        :id="item.id"
                        :requiredConnectorTypes="item.requiredConnectorTypes"
                        :chartData="item.chartData"
                        :name="item.name"
                        :description="item.description"
                        :path="item.path"
                        :icon="item.icon"
                        :type="item.type"
                        :hintLink="item.hintLink"
                        :showNewBadge="Boolean(item.showNewBadge)"
                        :badgeCount="item.badgeCount || 0"
                        :blocked="Boolean(item.blocked)"
                        @blocked-dashboard-click="onBlockedDashboardClick"
                    ></DashboardCard>
                </div>
            </div>
            <!-- Секция Аналитика -->
            <div v-if="groupedDashboards.analytics.length > 0" class="mb-8">
                <h3 class="dashboard-group-title">Аналитика</h3>
                <div class="dashboard-cards-grid">
                    <DashboardCard
                        v-for="(item, i) in groupedDashboards.analytics"
                        :key="`analytics-${i}`"
                        :id="item.id"
                        :requiredConnectorTypes="item.requiredConnectorTypes"
                        :chartData="item.chartData"
                        :name="item.name"
                        :description="item.description"
                        :path="item.path"
                        :icon="item.icon"
                        :type="item.type"
                        :hintLink="item.hintLink"
                        :showNewBadge="Boolean(item.showNewBadge)"
                        :badgeCount="item.badgeCount || 0"
                        :blocked="Boolean(item.blocked)"
                        @blocked-dashboard-click="onBlockedDashboardClick"
                    ></DashboardCard>
                </div>
            </div>
            <!-- Секция Настройки -->
            <div v-if="groupedDashboards.settings.length > 0" class="mb-8">
                <h3 class="dashboard-group-title">Настройки</h3>
                <div class="dashboard-cards-grid">
                    <DashboardCard
                        v-for="(item, i) in groupedDashboards.settings"
                        :key="`settings-${i}`"
                        :id="item.id"
                        :requiredConnectorTypes="item.requiredConnectorTypes"
                        :chartData="item.chartData"
                        :name="item.name"
                        :description="item.description"
                        :path="item.path"
                        :icon="item.icon"
                        :type="item.type"
                        :hintLink="item.hintLink"
                        :showNewBadge="Boolean(item.showNewBadge)"
                        :badgeCount="item.badgeCount || 0"
                        :blocked="Boolean(item.blocked)"
                        @blocked-dashboard-click="onBlockedDashboardClick"
                    ></DashboardCard>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import DashboardCard from '@/components/project/DashboardCard'
import router from '@root/src/router'
import { Li } from '@root/src/router'
export default {
    name: 'CardsViewDashboards',
    components: { DashboardCard },
    props: {
        projectId: {
            type: String,
            default: null,
        },
        dashBoards: {
            type: Array,
            default: () => {},
        },
        projectStatus: {
            type: String,
            default: 'open',
        },
    },
    data: () => ({}),
    computed: {
        groupedDashboards() {
            const groups = {
                communications: [],
                analytics: [],
                settings: [],
                marketplace: []
            }
            
            this.dashBoards.forEach(dashboard => {
                // Пропускаем маркетплейс
                if (dashboard.type === 'marketplace') {
                    return
                }
                
                if (dashboard.type === 'communications') {
                    groups.communications.push(dashboard)
                } else if (dashboard.type === 'analytics') {
                    groups.analytics.push(dashboard)
                } else if (dashboard.type === 'settings') {
                    groups.settings.push(dashboard)
                }
            })
            
            return groups
        },
    },
    methods: {
        goToBilling(e) {
            router.replace(`/project/${this.projectId}/billing/?section=tariffs`)
        },
        goToBotConnectorCreate() {
            router.push(`/project/${this.projectId}/addConnectorStage3?complete=true`)
        },
        onBlockedDashboardClick(dashboard) {
            this.$emit('blocked-dashboard-click', dashboard)
        },
    },
    created() {},
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.dashboard-group-title
    font-family: $font-family-base
    font-size: 11px
    font-weight: 800
    letter-spacing: .09em
    text-transform: uppercase
    color: $muted-light-new
    margin: 22px 0 12px

.dashboard-cards-grid
    display: grid
    grid-template-columns: repeat(3, minmax(0, 1fr))
    gap: 14px
    width: 100%

    @media (max-width: 1100px)
        grid-template-columns: repeat(2, minmax(0, 1fr))

    @media (max-width: 720px)
        grid-template-columns: minmax(0, 1fr)

    ::v-deep > *
        width: 100%
        min-width: 0
</style>
